<template>
    <Skeleton v-bind="primeVueProps">
        <slot />
    </Skeleton>
</template>

<script>
import { computed } from 'vue';
/**
 * ESkeleton - Abstraction wrapper around Primevue's Skeletton
 *
 * Usage:
 *   <e-skeleton></e-skeleton>
 *
 *   <e-skeleton width="20%" :animated="false"></e-skeleton>
 *
 *   <e-skeleton height="100px"></e-skeleton>
 *
 *   <e-skeleton :count="5"></e-skeleton>
 *
 *   <e-skeleton circle width="48px" height="48px"></e-skeleton>
 *
 *   <e-skeleton size="is-large"></e-skeleton>
 *
 *   <div>
 *     <e-skeleton circle width="32px" height="32px"></e-skeleton>
 *     <e-skeleton :count="3"></e-skeleton>
 *   </div>
 *
 * All Buefy e-skeleton props, events, and slots are supported.
 */
export default {
    name: 'ESkeleton',
    inheritAttrs: false,
    setup(props, { attrs }) {
        const primeVueProps = computed(() => {
            return {
                ...attrs,
                pt: {
                    root: {
                        class: 'tw:bg-background tw:mb-4 tw:rounded-md e-skeleton-root',
                    },
                },
            };
        });

        return { primeVueProps };
    },
};
</script>

<style lang="scss">
@import '~assets/scss/toolbox.scss';

.e-skeleton-root {
    position: relative;
    overflow: hidden;
    border-radius: $radius;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        animation: e-skeleton-shimmer 1.2s infinite;
        background: linear-gradient(
            90deg,
            transparent,
            rgba($white, 0.1),
            transparent
        );
    }
}

@keyframes e-skeleton-shimmer {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
}
</style>

